import { Observable } from 'rxjs';

export interface IntegrityMonitorRuleSetFormWebComponentSchema {
  ruleSetData?: RuleSetData;
  uniqueRuleSetNameValidator: (
    ruleSetName: string,
    companyId: string,
    excludedRuleSetId?: string
  ) => Observable<Object>;
}

export interface RuleSetData {
  _id: string;
  name: string;
  description: string;
}

export enum IntegrityMonitorRuleSetType {
  DEFAULT_OS = 1,
  DEFAULT_APP,
  CUSTOM,
}

export interface IntegrityMonitorRuleSet {
  _id: string;
  name: string;
  description: string;
  type: IntegrityMonitorRuleSetType;
  companyId: string;
  lastSyncTimestamp: number;
  version: string;
  assignedRulesIds: string[];
}

export enum RuleSetFormEvents {
  RULE_SET_CREATED = 'ruleSetCreated',
  RULE_SET_EDITED = 'ruleSetEdited',
}
